export const invoicePaymentStatusTableConfig = [
  {
    field: 'slNo',
    header: 'Sl. No',
    filter: false,
    visible: true,
    defaultPinned: true,
    sortable: false,
    order: 1,
    menuItems: [],
  },
  {
    field: 'invoicePaymentStatus',
    header: 'Invoice Payment Status',
    className: 'invoice-list-data-column',
    headerClassName: 'invoice-list-data-column',
    width: 180,
    filter: false,
    visible: true,
    defaultPinned: false,
    sortable: false,
    order: 2,
    menuItems: [],
  },
  {
    field: 'status',
    header: 'Status',
    className: 'invoice-list-data-column',
    headerClassName: 'invoice-list-data-column',
    width: 180,
    filter: false,
    visible: true,
    defaultPinned: false,
    sortable: false,
    order: 3,
    menuItems: [],
  },
  {
    field: 'action',
    header: 'Action',
    className: 'invoice-list-data-column invoice-list-action-column',
    headerClassName: 'invoice-list-data-column invoice-list-action-column',
    width: 180,
    exportable: false,
    filter: false,
    visible: true,
    defaultPinned: false,
    sortable: false,
    order: 4,
    menuItems: [],
  },
];
